import { getEncodedParamFromUrl, setTurboCookie } from '@turbodebt/turbo-shared'

export function setChatCompanyFromUrl(paramKey = 'l') {
  const urlParams = getEncodedParamFromUrl(paramKey) || ''
  const queryString = /** @type {string} */ (urlParams.params) || ''
  const urlParamsObj = new URLSearchParams(decodeURIComponent(queryString))
  const urlParamsFinal = Object.fromEntries(urlParamsObj.entries())
  if (
    typeof document !== 'undefined' &&
    urlParamsFinal?.company &&
    !document.cookie.includes('chatCompany=')
  ) {
    // @ts-expect-error type mismatch from util fxn
    setTurboCookie('chatCompany', urlParamsFinal.company, {})
  }
}
